module.exports = __webpack_public_path__ + "img/regenera.bfe63057.png";